import { CloseOutlined } from '@ant-design/icons';
import { Button, Flex } from 'antd';
import React, { useEffect, useState } from 'react';

// Adjusts position to stay within viewport boundaries
const SpellCheckerTooltip = ({ tooltip, tooltipRef, onSuggestionClick, onIgnoreWord, onMouseEnter, onMouseLeave, onClose }) => {
  const [position, setPosition] = useState({
    top: tooltip?.position?.top ?? 0,
    left: tooltip?.position?.left ?? 0,
  });

  useEffect(() => {
    if (!tooltip || !tooltipRef.current) return;

    const tooltipRect = tooltipRef.current.getBoundingClientRect();
    const viewportHeight = window.innerHeight;
    const viewportWidth = window.innerWidth;

    let newTop = tooltip.position.top;
    let newLeft = tooltip.position.left;

    // Check bottom edge of viewport
    if (tooltip.position.top + tooltipRect.height > viewportHeight) {
      const wordTop = tooltip.position.wordTop || tooltip.position.top - 24;
      newTop = wordTop - tooltipRect.height;
    }

    // Check right edge of viewport
    if (tooltip.position.left + tooltipRect.width > viewportWidth) {
      newLeft = Math.max(0, viewportWidth - tooltipRect.width - 10);
    }

    setPosition({
      top: newTop,
      left: newLeft,
    });
  }, [tooltip, tooltipRef]);

  if (!tooltip) return null;

  return (
    <Flex
      ref={tooltipRef}
      className='absolute z-[2000] bg-lila-background rounded-md p-s'
      vertical
      gap={8}
      style={{
        top: `${position.top}px`,
        left: `${position.left}px`,
        boxShadow: '0px 0px 8px 0px rgba(76, 76, 76, 0.20), 0px 4px 16px 0px rgba(76, 76, 76, 0.40)',
      }}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <Flex gap={8} align='center'>
        <p className='caption1 text-grey-medium'>Suggestion de correction</p>
        <CloseOutlined onClick={onClose} className='text-grey-medium cursor-pointer w-m' />
      </Flex>
      <Flex gap={8} vertical className='bg-white rounded-sm p-s'>
        <p className='caption2 text-grey-medium'>{tooltip.reason}</p>
        <p className='caption1 text-grey-medium line-through'>{tooltip.word}</p>
        <Flex gap={8} align='center'>
          {tooltip.suggestions.slice(0, 5).map((suggestion, index) => (
            <Button className='btn-success' size='small' key={index} onClick={() => onSuggestionClick(suggestion)}>
              {suggestion}
            </Button>
          ))}
          <Button type='text' size='small' onClick={() => onIgnoreWord(tooltip.word)}>
            Ignorer
          </Button>
        </Flex>
      </Flex>
    </Flex>
  );
};

export default SpellCheckerTooltip;
